addEventListener('DOMContentLoaded', _ => {
    Object.defineProperty(document, 'top', {
        get() {
            return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0)
        },
    })
    const navElement = document.querySelector('#navigation')
    const nextSibling = navElement.parentElement.querySelector('#navigation + *')
    const mirror = navElement.cloneNode(true)
    mirror.classList.add('mirror')
    navElement.parentElement.insertBefore(mirror, nextSibling)

    const firstRow = navElement.firstElementChild
    const startHeight = firstRow.clientHeight
    const desiredHeight = 100
    const startingPaddingRems = 0
    const paddingRems = Math.max(0, (100 - ((firstRow.clientHeight - desiredHeight) * document.top / startHeight)) / 100 * startingPaddingRems)


    firstRow.style.paddingTop = `${paddingRems}rem`
    firstRow.style.paddingBottom = `${paddingRems}rem`
    addEventListener('scroll', _ => {
        const newPaddingRems = Math.max(0, (100 - ((firstRow.clientHeight - desiredHeight) * document.top / startHeight)) / 100 * startingPaddingRems)
        if (newPaddingRems > 0) {
            firstRow.style.paddingTop = `${newPaddingRems}rem`
            firstRow.style.paddingBottom = `${newPaddingRems}rem`
        }
        // if (document.top > navElement.clientHeight) {
        //     navElement.classList.add('scrolled')
        // } else {
        //     navElement.classList.remove('scrolled')
        // }
    })

    const hamburger = document.querySelector('#nav-toggle')
    const navItems = document.querySelector('#navigation-items')
    hamburger.addEventListener('click', _ => {
        navItems.classList.toggle('open')
        hamburger.classList.toggle('opened')
    })
})
